
export default class ColorUtil
{

    public static hexHashStringToNumber(hex:string):number
    {
        return parseInt(hex.substring(1), 16);
    }

    public static hexToRGBA(hex:string, alpha:number = 1):string
    {
        const r = parseInt(hex.substring(1, 3), 16);
        const g = parseInt(hex.substring(3, 5), 16);
        const b = parseInt(hex.substring(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
}